import React from 'react'
import Navbar from '../components/layout/NavbarNew'
import Footer from '../components/layout/Footer'
import LandingPage from '../components/sections/LandingPage'
import Services from '../components/sections/Services'
import Aboutus from '../components/sections/Aboutus'
import WhyChooseUs from '../components/sections/WhyChooseUs'
import OurClients from '../components/sections/OurClients'
import Testimonials from '../components/sections/Testimonials'

function Home() {
  return (
    <div className="app-container">
      <main className="main-content">
        <Navbar />
        <LandingPage />
        <Services />
        <Aboutus />
        <WhyChooseUs />
        {/* <OurClients /> */}
        <Testimonials />
      </main>
      <Footer />
    </div>
  )
}

export default Home
